import React from 'react';

const ToggleButtonSimple = ({value, onChange, className, disabled = false}) => {
    return (
        <div className={`switch ${className}`} disabled={disabled} onClick={onChange}>
            <input type="checkbox" checked={value} readOnly={true}/>
            <span className="slider round"></span>
        </div>
    );
}

export default ToggleButtonSimple;